import { c as createSvgIcon } from '../../createSvgIcon-de76dc64.js';
import React from 'react';
import 'tslib';
import '@mui/material/SvgIcon';

var CheckBoxBlankWhiteFilled = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("rect", { rx: "2", fill: "white", strokeWidth: "2", width: "18", height: "18", x: "3", y: "3" }),
    React.createElement("path", { d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" })), 'CheckBoxBlankWhiteFilled');

export { CheckBoxBlankWhiteFilled as default };
